/**
 * 六個登入版型共用的表單本體：帳號 / 密碼 / 錯誤訊息 / 送出鈕。
 *
 * 版型之間只換外觀，不換結構 —— 外觀靠各版型 root 上的 CSS 變數
 * （`--lv-*`，見 login.css）；id / name / ref 一律維持原本的
 * `username` / `login-password` / `login` / `login-form`，
 * 瀏覽器自動填入與既有自動化腳本才不會斷。
 */
import React, { useState } from 'react';

const IconUser = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21c0-4 3.6-7 8-7s8 3 8 7" />
  </svg>
);
const IconLock = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="4" y="11" width="16" height="10" rx="2" />
    <path d="M8 11V7a4 4 0 0 1 8 0v4" />
  </svg>
);
const IconEye = ({ off }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12z" />
    <circle cx="12" cy="12" r="3" />
    {off && <path d="M4 4l16 16" />}
  </svg>
);

export default function LoginFields(props) {
  const {
    username, password, onChange, onInput, onSubmit,
    usernameRef, passwordRef, error, busy,
    // 版型可覆寫文案 / 是否顯示 label 與 icon
    submitLabel = '登入',
    busyLabel = '登入中…',
    showLabels = true,
    showIcons = true,
  } = props;
  const [reveal, setReveal] = useState(false);

  return (
    <form
      className="lv-form"
      id="login-form"
      name="login-form"
      method="post"
      action="/api/login"
      autoComplete="on"
      onSubmit={(e) => { e.preventDefault(); if (!busy) onSubmit(); }}
      noValidate
    >
      <div className="lv-group">
        {showLabels && <label className="lv-label" htmlFor="username">帳號</label>}
        <div className="lv-field">
          {showIcons && <span className="lv-icon"><IconUser /></span>}
          <input
            className="lv-input"
            type="text"
            id="username"
            name="username"
            placeholder="Username"
            autoComplete="username"
            autoCapitalize="none"
            spellCheck="false"
            ref={usernameRef}
            value={username}
            onChange={onChange}
            onInput={onInput}
          />
        </div>
      </div>

      <div className="lv-group">
        {showLabels && <label className="lv-label" htmlFor="login-password">密碼</label>}
        <div className="lv-field">
          {showIcons && <span className="lv-icon"><IconLock /></span>}
          <input
            className="lv-input"
            type={reveal ? 'text' : 'password'}
            id="login-password"
            name="login-password"
            placeholder="Password"
            autoComplete="current-password"
            ref={passwordRef}
            value={password}
            onChange={onChange}
            onInput={onInput}
          />
          <button
            type="button"
            className="lv-eye"
            onClick={() => setReveal((v) => !v)}
            aria-label={reveal ? '隱藏密碼' : '顯示密碼'}
            tabIndex={-1}
          >
            <IconEye off={reveal} />
          </button>
        </div>
      </div>

      <div className={`lv-error${error ? ' is-visible' : ''}`} role="alert" aria-live="polite">
        {error || ' '}
      </div>

      <button type="submit" id="login" name="login" className="lv-btn" disabled={busy}>
        <span className="lv-btn-label">{busy ? busyLabel : submitLabel}</span>
        <span className="lv-btn-arrow" aria-hidden="true">→</span>
      </button>
    </form>
  );
}
